import * as stateActions from '../store/actions';

export const openGameLauncher = () => { };
export const setGameOpened = () => { };
export const iosGames = {};

export const hideMainBanner = stateActions.hideMainBanner;
